import { Theme } from '@emotion/react';
import { ReactNode } from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme, type SxProps } from '@mui/material/styles';

interface FormSectionHeaderProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
  description?: string | ReactNode;
  /** Typography variant for the description; `body2` uses the support text color. */
  descriptionVariant?: 'caption' | 'body2';
}

export const FormSectionHeader = ({
  children,
  sx,
  description,
  descriptionVariant = 'caption',
}: FormSectionHeaderProps) => {
  const theme = useTheme();

  return (
    <Stack direction="column" gap={0.35} sx={{ ...sx, width: '100%' }}>
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{ width: '100%' }}
      >
        <Typography
          variant="body1"
          sx={{ fontWeight: 600, color: theme.palette.semantic.text.title2 }}
        >
          {children}
        </Typography>
      </Stack>
      {description && (
        <Typography
          variant={descriptionVariant}
          sx={
            descriptionVariant === 'body2'
              ? { color: theme.palette.semantic.text.support }
              : undefined
          }
        >
          {description}
        </Typography>
      )}
    </Stack>
  );
};
